"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrerequisiteTypeToJSON = exports.PrerequisiteTypeFromJSONTyped = exports.PrerequisiteTypeFromJSON = exports.PrerequisiteType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var PrerequisiteType;
(function (PrerequisiteType) {
    PrerequisiteType["EVENT"] = "EVENT";
    PrerequisiteType["QUESTCOMPLETION"] = "QUEST_COMPLETION";
    PrerequisiteType["QUESTMEMBERSHIP"] = "QUEST_MEMBERSHIP";
    PrerequisiteType["TOKENBALANCE"] = "TOKEN_BALANCE";
    PrerequisiteType["LEVEL"] = "LEVEL";
    PrerequisiteType["NFT"] = "NFT";
    PrerequisiteType["GUILDMEMBERSHIP"] = "GUILD_MEMBERSHIP";
    PrerequisiteType["REFERRAL"] = "REFERRAL";
    PrerequisiteType["MENUORDER"] = "MENU_ORDER";
    PrerequisiteType["REDEEMLOOTBOX"] = "REDEEM_LOOTBOX";
    PrerequisiteType["CHALLENGEMEMBERSHIP"] = "CHALLENGE_MEMBERSHIP";
})(PrerequisiteType = exports.PrerequisiteType || (exports.PrerequisiteType = {}));
function PrerequisiteTypeFromJSON(json) {
    return PrerequisiteTypeFromJSONTyped(json, false);
}
exports.PrerequisiteTypeFromJSON = PrerequisiteTypeFromJSON;
function PrerequisiteTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.PrerequisiteTypeFromJSONTyped = PrerequisiteTypeFromJSONTyped;
function PrerequisiteTypeToJSON(value) {
    return value;
}
exports.PrerequisiteTypeToJSON = PrerequisiteTypeToJSON;
